<form [formGroup]="formContactDetails" (ngSubmit)="onContactDetailsUpdateSubmit()">
  <div class="formgrid grid p-fluid">
    <!-- disclaimer -->
    <div class="field w-12 col-12 md:col-6">
      <p class="font-normal text-600">
        <span class="text-primary font-medium">TAKE NOTE:</span> Updating customer contact details
        incorrectly influences their billing communication and their ability to login to the portal.
      </p>
    </div>

    <div class="field col-12 lg:col-6" *ngFor="let field of formFields">
      <label [attr.for]="field.controlName">{{ field.label }}</label>
      <!-- if form -->
      <!-- all else -->
      <input
        pInputText
        [attr.type]="field.type"
        [attr.id]="field.controlName"
        [attr.placeholder]="field.placeholder"
        [formControlName]="field.controlName"
        class="w-full mb-3"
        *ngIf="field.type !== 'tel' && field.type !== 'email'"
        (blur)="f[field.controlName].markAsDirty()"
      />

      <!-- email -->
      <input
        pInputText
        *ngIf="field.type === 'email'"
        [attr.type]="field.type"
        [attr.id]="field.controlName"
        [attr.placeholder]="field.placeholder"
        [formControlName]="field.controlName"
        class="w-full mb-1"
        (blur)="f[field.controlName].markAsDirty()"
        pKeyFilter="email"
      />

      <!-- telephone -->
      <input
        pInputText
        *ngIf="field.type === 'tel'"
        [attr.type]="field.type"
        [attr.id]="field.controlName"
        [attr.placeholder]="field.placeholder"
        [formControlName]="field.controlName"
        class="w-full mb-1"
        pKeyFilter="num"
        [pattern]="rsaPhoneNumberRegex"
        (blur)="f[field.controlName].markAsDirty()"
      />
      <small *ngIf="field.type === 'tel'" id="telephone-help" class="text-600 text-800 block"
        >Telephone/Mobile number starting with 0 or 27</small
      >
      <!-- errors -->
      <small
        class="p-error text-base"
        *ngIf="field.type === 'tel' && f[field.controlName]?.errors?.['pattern']"
      >
        Please enter a <strong>valid</strong> South African telephone number</small
      >

      <small
        *ngIf="
          f &&
          f[field.controlName] &&
          f[field.controlName].errors &&
          f?.[field.controlName]?.errors?.['required']
        "
        class="p-error text-base"
        ><strong>{{ field.label }}</strong> is required</small
      >
      <small
        *ngIf="field.type === 'email' && f['email']?.errors?.['email']"
        severity="error"
        class="p-error text-base"
        >Please enter a <strong>valid</strong> email address</small
      >
    </div>
    <div class="field w-12 col-12 md:col-6">
      <button
        *appHasPermission="'customers.edit'"
        pButton
        type="submit"
        label="Update Customer Contact Details"
        class="p-button p-button-success"
      ></button>
    </div>
    <div class="field col-12">
      <p-message
        #errormsg
        *ngIf="errorMessage != ''"
        severity="error"
        [text]="errorMessage"
        class="w-full"
        hideTransitionOptions="500ms ease-out"
      ></p-message>
    </div>
  </div>
</form>
